import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const parentEasypostSettings = defineIntegrationSettings({
  fields: { enabled: z.boolean() },
  secrets: {
    prodApiKey: z.string().trim().min(1, "Production API key is required"),
    testApiKey: z.string().trim().min(1, "Test API key is required"),
  },
  connectOnly: {},
  computed: { accountId: z.string().nullable() },
});
